import withErrorCheck from "../CheckError";
import { IGroupMembers } from "@grassrootly/api/entities";
import server from "../Server";

export type GetGroupMembersByDateParams = {
  gid: number;
  p_date_from?: string; // YYYY-MM-DDTHH:mm:ss (optional when p_season_id is provided)
  p_date_to?: string;   // YYYY-MM-DDTHH:mm:ss (optional when p_season_id is provided)
  p_season_id?: number;  // Optional season_id for seasonal filtering
};

export const GetGroupMembersByDate = async (
  params: GetGroupMembersByDateParams
): Promise<IGroupMembers[]> => {
  const groupMembers = withErrorCheck(
    // @ts-ignore
    await server.rpc("group_players_with_total_experience", params)
  );

  if (!groupMembers) return [] as IGroupMembers[];

  return groupMembers as IGroupMembers[];
};
